import React from 'react';
import { renderRoutes } from 'react-router-config';

function Stories(props: any): React.ReactElement {
  return props?.route?.routes ? renderRoutes(props.route.routes, props) : <>All Stories</>;
}

export default Stories;
